/*
 * @Author: your name
 * @Date: 2024-10-11 15:27:05
 * @LastEditTime: 2025-01-07 16:11:47
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \carlife_h5\src\request\api.js
 */
let baseUrl, upload;

if (process.env.NODE_ENV === "development") {
  baseUrl = "http://api-test.chinaubi.com/pjms/insurance/csh";
  upload = "https://api-test.chinaubi.cn";
} else if (process.env.NODE_ENV === "production") {
  baseUrl = "" + "/pjms/insurance/csh";
  upload = "";
}
export default {
  delOrder: baseUrl + "/ins/policy/delOrder", //删除车险订单
  queryInsInfo: baseUrl + "/ins/policy/queryInsInfo", //查询投保用的信息
  queryOrderDetails: baseUrl + "/ins/policy/queryOrderDetails", //查询订单详情
  queryOrderList: baseUrl + "/ins/policy/queryOrderList", //查询订单列表
  getAreaList: baseUrl + "/ins/policy/getAreaList", //查询投保省市区
  queryInsOptPlan: baseUrl + "/ins/policy/queryInsOptPlan", //自定义投保险种查询
  queryInsRecPlan: baseUrl + "/ins/policy/queryInsRecPlan", //查询投保推荐方案
  queryInsCompany: baseUrl + "/ins/policy/queryInsCompany", //查询可报价保司列表
  quote: baseUrl + "/ins/policy/quote", //报价
  getParams: baseUrl + "/ins/policy/getParams", //获取解密后的参数
  getUploadDetail: baseUrl + "/ins/policy/getUploadDetail", //保审核补充信息-查询
  submitUploadFiles: baseUrl + "/ins/policy/submitUploadFiles", //投保审核补充信息-完成填写
  postUnderwriting: baseUrl + "/ins/policy/postUnderwriting", //购买车险 - 下一步 - 核保提交
  upload: upload + "/file/v1/upload", //购买车险 - 下一步 - 核保提交
  recogniseImage: baseUrl + "/ins/policy/recogniseImage", //OCR识别
  getDealer: baseUrl + "/ins/policy/getDealer", //获取经销商列表
  queryVehicleModel: baseUrl + "/ins/policy/queryVehicleModel", //获取车辆型号列表
  cshViewToPay: baseUrl + "/ins/policy/cshViewToPay", //支付获取保司url
  getCurrentTime: baseUrl + "/ins/policy/getCurrentTime", //获取当前时间
  submitQuoteInfo: baseUrl + "/ins/policy/submitQuoteInfo", //获取当前时间
  delOrder: baseUrl + "/ins/policy/delOrder", //删除订单
  cshApplyPay: baseUrl + "/ins/policy/cshApplyPay", //支付获取保司url
  sendEleApplicationSign: baseUrl + "/ins/policy/sendEleApplicationSign", //支付获取人保司url
  reSelectPlan: baseUrl + "/ins/policy/reSelectPlan",
  payProblem: baseUrl  + "/ins/policy/payProblem"
};



// WEBPACK FOOTER //
// ./src/request/api.js